<div class="p-1 pt-2 breadcrumb-wrapper">
<ol class="breadcrumb p-0">
  <li *ngFor="let breadcrumb of breadcrumbs" class="{{ checkUrl(breadcrumb.url) }}">
    <span [routerLink]="breadcrumb.url"  class="{{checkSpan(breadcrumb.url)}}">
      {{ breadcrumb.label }}
    </span>
  </li>
</ol>
</div>
